import { takeLatest, call, put } from 'redux-saga/effects';
import { getDetailedInvoiceReport, getUninvoicedReport } from 'utils/apis/invoiceReports';
import {
    startDetailedReport,
    setDetailedReport,
    startUninvoicedReport,
    setUninvoicedReport,
    completedAction
} from './invoiceReports.slice';

function* detailedReportHandler({ payload }) {
    try {
        const response = yield call(getDetailedInvoiceReport, payload || {});
        yield put(setDetailedReport(response));
    } catch (error) {
        // swallow or handle
        console.error(error);
    } finally {
        yield put(completedAction());
    }
}

function* uninvoicedReportHandler({ payload }) {
    try {
        const response = yield call(getUninvoicedReport, payload || {});
        yield put(setUninvoicedReport(response));
    } catch (error) {
        console.error(error);
    } finally {
        yield put(completedAction());
    }
}

export function* watchInvoiceReports() {
    yield takeLatest(startDetailedReport.type, detailedReportHandler);
    yield takeLatest(startUninvoicedReport.type, uninvoicedReportHandler);
}
